"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = exports.CompositeConstraint = void 0;
const AbstractConstraint_1 = require("./AbstractConstraint");
const ConstraintFactory_1 = require("./ConstraintFactory");
/**
 * This constraint evaluates a set of sub-constraints.
 * Its return value depends on the result of the sub-constraints and on the algorithm to be used to compute the result:
 * 1) If `algorithm` is `all` then all sub-constraints must be respected for this constraint to return `true`
 * 2) If `algorithm` is `any` then at least one sub-constraint must be respected for this constraint to return `true`
 * The constraint type for this constraint is `COMPOSITE_CONSTRAINT`
 * Configuration:
 * * type: 'COMPOSITE_CONSTRAINT'
 * * algorithm: can be `all` or `any`
 * subRules: [ ] list of constraints to be evaluated.
 */
class CompositeConstraint extends AbstractConstraint_1.AbstractConstraint {
    isRespected(data) {
        if (!this.config.subRules) {
            // TODO: log a warning
            return true;
        }
        const validCount = this.config.subRules.reduce((total, ruleConfig) => {
            return (total +
                (ConstraintFactory_1.ConstraintFactory.create(ruleConfig).isRespected(data) ? 1 : 0));
        }, 0);
        if (this.config.algorithm === 'any') {
            return validCount > 0;
        }
        else {
            return this.config.subRules.length === validCount;
        }
    }
}
exports.CompositeConstraint = CompositeConstraint;
exports.NAME = 'COMPOSITE_CONSTRAINT';
//# sourceMappingURL=CompositeConstraint.js.map